// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"

let $ = window.$;
let _ = window._;
let Backbone = window.Backbone;

const bindWindowVendorGlobal = (name, updateExport) => {
    const descriptor = Object.getOwnPropertyDescriptor(window, name);

    if (descriptor && !descriptor.configurable) {
        updateExport(window[name]);
        return;
    }

    let value = window[name];
    updateExport(value);

    Object.defineProperty(window, name, {
        configurable: true,
        enumerable: descriptor ? descriptor.enumerable : true,
        get() {
            return value;
        },
        set(nextValue) {
            value = nextValue;
            updateExport(nextValue);
        }
    });
};

bindWindowVendorGlobal("$", value => {
    $ = value;
});
bindWindowVendorGlobal("_", value => {
    _ = value;
});
bindWindowVendorGlobal("Backbone", value => {
    Backbone = value;
});

export {
    $,
    _,
    Backbone,
};
